import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(VImg, {
    staticClass: "discount-banner-image",
    class: _setup.isMobile
      ? "discount-banner-image-mobile"
      : "discount-banner-image-desktop",
    attrs: {
      src: "/static/_v1/pd/pictures/analyzes/molecule.png",
      "min-width": _setup.size,
      "min-height": _setup.size,
      "max-height": _setup.size,
      "max-width": _setup.size,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }